// src/components/home/HeroSection.js
import React from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';

function HeroSection() {
  return (
    <section className="hero-section-container">
      {/* COLONNE DE L'IMAGE (à gauche sur desktop) */}
      <div className="hero-image-column">
        <img 
          src="/images/visuel/fusee-infocolab.png" // Assurez-vous que ce chemin est correct depuis le dossier public
          alt="INFO COLAB - Illustration et logo" 
          className="hero-main-image"
        />
        <Link to="/services" className="btn btn-primary hero-cta-button hero-cta-mobile">
          Explorer nos services
        </Link>
      </div>
      {/* COLONNE DU TEXTE (à droite sur desktop) */}
      <div className="hero-text-column">
        <h1>
          INFO COLAB : <span className="highlight-text">Donnons Vie</span> à Vos Projets Web
        </h1>
        <p>
          De la conception créative au développement full-stack, nous transformons vos idées en expériences numériques performantes et sur mesure. Votre vision est notre priorité.
        </p>
        <Link to="/services" className="btn btn-primary hero-cta-button hero-cta-desktop">
          Explorer nos services
        </Link>
      </div>
    </section>
  );
}

export default HeroSection;